import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketOutPing extends PacketOut {
    private readonly clientTimeMs: number;

    constructor(clientTimeMs: number) {
        super(OutboundPacketType.PING);
        this.clientTimeMs = clientTimeMs;
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {
            client_time_ms: this.clientTimeMs,
        };
    }
}
